export const DevicePrivileges = {
    SuperOwner: 3,
    Owner: 0,
    Unrestricted: 1,
    Limited: 2,
};
